<template>
  <div class="text-center">
    <a class="btn-close-alert btn btn-secondary w-100" href="#" @click.prevent="handleClick()">
      <span>確定</span>
    </a>
  </div>
</template>

<script setup>
import useAlert from '@global/composable/useAlert';

const { closeAlert } = useAlert();

const props = defineProps({
  alert: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

function handleClick() {
  if (typeof props.alert.callback === 'function') {
    props.alert.callback();
  }
  closeAlert(props.index);
}
</script>
